<template>
    <div>
        <modal :show.sync="addExpense" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar gasto</h6>
                <div class="form-group">
                    <label>Gasto *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="nombre del gasto"
                                placeholder="nombre del gasto"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('nombre del gasto')"
                                v-model="expenseName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="expenseValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelAddExpense()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="addExpenseToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editExpense" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar gasto</h6>
                <div class="form-group">
                    <label>Gasto *</label>
                    <fg-input   tabindex="2"
                                type="text"
                                name="gasto"
                                :disabled="expenseLocked"
                                placeholder="gasto"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('gasto')"
                                v-model="expenseName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 tabindex="3" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="expenseValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelEditExpense()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="editExpenseToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Hoja de trabajo</h4>
        </div>
        <!-- Expenses -->
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Gastos del vehículo</h6>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.periodicity"
                                :error="getError('periodicidad')"
                                v-model="periodicity">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="periodicity">
                            <el-option 
                                    class="select-warning"
                                    value="Diaria"
                                    label="Diaria">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Semanal"
                                    label="Semanal">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="periodicity == 'Diaria'" class="form-group">
                        <label>Número de días que trabaja en la semana</label>
                        <fg-input   type="number"
                                    tabindex="1"
                                    name="días"
                                    placeholder="días"
                                    autocomplete="off"
                                    v-validate="modelValidations.periodicity"
                                    data-vv-id = "días"
                                    :error="getError('días')"
                                    v-model="periodicity_days">
                        </fg-input>
                    </div>
                <div v-if="!periodicityFlag && periodicity == ''" class="alert alert-danger mt-2">
                    <span>Seleccione la periodicidad de los gastos</span>
                </div>
                <div v-if="periodicity == 'Diaria' && !periodicityDaysFlag" class="alert alert-danger mt-2">
                    <span>Especifique los días que trabaja en la semana</span>
                </div>
                <!--<div class="form-group">
                    <label>Ingrese el número de días que trabaja el vehículo al mes *</label>
                    <fg-input   tabindex="4"
                                type="number"
                                name="días"
                                placeholder="días"
                                autocomplete="off"
                                v-validate="modelValidations.item_costs"
                                :error="getError('días')"
                                v-model="monthlyNumber">
                    </fg-input>
                </div>-->
                <div v-if="!alertFlag" class="alert alert-danger mt-2">
                    <span>No ha ingresado el número de días que trabaja el vehículo al mes</span>
                </div>
                <el-table v-if="actualExpenses.length" :data="actualExpenses"  ref="expensesTable"  @row-dblclick="showEditExpensesMethod" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column label="Gasto" property="name"></el-table-column>
                    <el-table-column label="Valor">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.value)}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="Total">
                        <template slot-scope="scope">
                            <span v-if="monthlyNumber != ''">{{ setFormat(scope.row.value * monthlyNumber)}}</span>
                            <span v-else>{{ setFormat(0)}}</span>
                        </template>
                    </el-table-column> -->
                </el-table>
                
                <div>
                    <p-button 
                        @click="addExpenseMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar gasto
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="editExpenseMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar gasto
                    </p-button>
                    <br>
                    <p-button v-if="currentRow && currentRow.locked == false"
                        @click="removeExpenseMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar gasto
                    </p-button>
                </div>
                <div v-if="allExpensesMonthlyCostComputed != 0" class="alert alert-warning mt-2">
                    <span>Costo gastos mes: {{setFormat(allExpensesMonthlyCostComputed)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <!-- /Expenses -->
        <!-- add Taxes -->
        <modal :show.sync="addTax" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar impuesto</h6>
                <div class="form-group">
                    <label>Impuesto *</label>
                    <fg-input   tabindex="5"
                                type="text"
                                name="nombre del impuesto"
                                placeholder="nombre del impuesto"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('nombre del impuesto')"
                                v-model="taxName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.periodicity"
                                :error="getError('periodicidad')"
                                v-model="taxPeriodicity">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="taxPeriodicity">
                            <el-option 
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Anual"
                                    label="Anual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="alert alert-info">
                    <span>Asegúrate de agregar el valor de forma {{taxPeriodicity}}</span>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 tabindex="6" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="taxValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelAddTax()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="addTaxToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editTax" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar impuesto</h6>
                <div class="form-group">
                    <label>impuesto *</label>
                    <fg-input   tabindex="7"
                                type="text"
                                name="impuesto"
                                :disabled="taxLocked"
                                placeholder="impuesto"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('impuesto')"
                                v-model="taxName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.periodicity"
                                :error="getError('periodicidad')"
                                v-model="taxPeriodicity">
                            <el-select 
                                    :disabled="taxLocked"
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="taxPeriodicity">
                            <el-option 
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Anual"
                                    label="Anual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="alert alert-info">
                    <span>Asegúrate de agregar el valor de forma {{taxPeriodicity}}</span>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 tabindex="8" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="taxValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelEditTax()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="editTaxToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <!-- /add Taxes -->
        <!--Taxes -->
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Impuestos</h6>
            </div>
            <div class="card-body">
                <el-table v-if="actualTaxes.length" :data="actualTaxes"  ref="taxesTable"   @row-dblclick="showEditTaxesMethod" highlight-current-row @current-change="handleTaxCurrentChange">
                    <el-table-column label="Impuesto" property="name"></el-table-column>
                    <el-table-column label="Valor">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.value)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div>
                    <p-button 
                        @click="addTaxMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar impuesto
                    </p-button>
                    <br>
                    <p-button v-if="currentTaxRow"
                        @click="editTaxMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar impuesto
                    </p-button>
                    <br>
                    <p-button v-if="currentTaxRow && currentTaxRow.locked == false"
                        @click="removeTaxMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar impuesto
                    </p-button>
                </div>
                <div v-if="allTaxesMonthlyCostComputed != 0" class="alert alert-warning mt-2">
                    <span>Costo impuestos mes: {{setFormat(allTaxesMonthlyCostComputed)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <!-- /Taxes -->
        <div v-if="allCostsComputed != 0" class="alert alert-success">
            <span>Costos totales mes: {{ setFormat(allCostsComputed)}}</span>
        </div>
        <div v-if="this.$store.state.isCustomer && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0" class="alert alert-success">
            <span>Ventas mensuales: {{ setFormat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales)}}</span>
        </div>
        <div v-if="this.$store.state.isSpouse && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0" class="alert alert-success">
            <span>Ventas mensuales: {{ setFormat(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales)}}</span>
        </div>
        <div v-if="this.$store.state.isGuarantor && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0" class="alert alert-success">
            <span>Ventas mensuales: {{ setFormat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales)}}</span>
        </div>
        <div class="text-right">
            <p-button v-if="allCostsComputed != 0" @click="saveCosts()" type="warning">Siguiente</p-button>
            <p-button @click="toSalesCostsSelection()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn} from 'element-ui'
    import Expenses from 'src/util/Services/Expenses'
    import Taxes from 'src/util/Services/Taxes'
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal
        },
        data() {
        return {
            form: {
                average_selection: '',
            },
            alertFlag: true,
            periodicity: '',
            periodicityFlag: true,
            periodicityDaysFlag: true,
            periodicity_days: 0,
            expenses : [],
            taxes: [],
            actualExpenses: [],
            actualTaxes: [],
            currentRow: null,
            currentTaxRow: null,
            addExpense: false,
            editExpense: false,
            addTax: false,
            editTax: false,
            addExpenseIndex: null,
            monthlyNumber: '',
            expenseName: '',
            expenseValue: '',
            expenseLocked: false,
            taxName: '',
            taxValue: '',
            taxPeriodicity: '',
            taxLocked: false,
            products: [
                
            ],
            costs: [],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                sales: {
                    required: false
                },
                product_name: {
                    required: false,
                    max: 32
                },
                item_costs: {
                    required: true,
                    min: 1,
                    max: 28
                },
                average_selection: {
                    required: false
                },
                item_name: {
                    required: false,
                    max: 32
                },
            },
        }
        },
        watch: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            periodicity_days: function(newVal, oldVal) {
                if(newVal < 0) {
                    this.periodicity_days = 1;
                }
                else if(newVal > 7) {
                    this.periodicity_days = 7;
                }
                else if(newVal == '') {
                    this.periodicity_days = 0;
                }
                else {
                    this.periodicity_days = parseFloat(newVal)
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            periodicity: function(newVal, oldVal) {
                
                if (oldVal != '') {
                    this.periodicity_days = 0;
                }
            }
        },
        computed: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostTotalComputed() {
                var total = this.productQuantity * this.productCostUnity;
                this.productCostTotal = total;
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthlyCostComputed() {
                var total = 0;
                if (this.monthlyNumber != '') {
                    var total = this.productQuantity * this.productCostUnity * this.monthlyNumber;
                    this.productMonthlyCost = total;
                }
                return total;
            },
            // allExpensesMonthlyCostComputed() {
            //     var sum = 0;
            //     if (this.monthlyNumber != '') {
            //         for (let i=0;i<this.actualExpenses.length;i++) {
            //             sum = sum + (this.actualExpenses[i].value * parseFloat(this.monthlyNumber));
            //         }
            //         this.alertFlag = true;
            //     }
            //     else {
            //         for (let i=0;i<this.actualExpenses.length;i++) {
            //             sum = sum + (this.actualExpenses[i].value);
            //         }
            //         if (sum != 0) {
            //             this.alertFlag = false;
            //         }
            //     }
            //     return sum   
            // },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allExpensesMonthlyCostComputed() {
                var sum = 0;
                var flag = 0;
                if (this.periodicity == 'Diaria') {
                    this.periodicityDaysFlag = true;
                    if(this.periodicity_days != 0) {
                        flag = parseInt(this.periodicity_days)* 4;
                    }
                    else {
                        this.periodicityDaysFlag = false;
                    }
                }
                else if (this.periodicity == 'Semanal') {
                    flag = 4;
                }
                else if (this.periodicity == 'Mensual') {
                    flag = 1;
                }
                this.periodicityFlag = true;
                for (let i=0;i<this.actualExpenses.length;i++) {
                    if (this.actualExpenses[i].locked) {
                        if (flag == 0 && this.actualExpenses[i].value != 0) {
                                this.periodicityFlag = false;
                        }
                        sum = sum + ((this.actualExpenses[i].value)* flag);
                    }
                }
                return sum   
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allTaxesMonthlyCostComputed() {
                var sum = 0;
                for (let i=0;i<this.actualTaxes.length;i++) {
                    if (this.actualTaxes[i].periodicity == 'Mensual') {
                        sum = sum + this.actualTaxes[i].value;
                    }
                    else {
                        sum = sum + (this.actualTaxes[i].value/ 12);
                    }
                    
                }
                return sum 
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allCostsComputed() {
                return this.allExpensesMonthlyCostComputed + this.allTaxesMonthlyCostComputed
            }
        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showEditExpensesMethod (row) {
                this.expenseName= row.name;
                this.expenseValue= row.value;
                this.expenseLocked = row.locked;
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showEditTaxesMethod (row) {
                this.taxName= row.name;
                this.taxValue= row.value;
                this.taxLocked = row.locked;
                this.taxPeriodicity = row.periodicity;
                this.editTax = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleTaxCurrentChange(currentRow, oldCurrentRow) {
                this.currentTaxRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.itemName == '' || this.itemPercent == 0) {
                            this.showNotificationError('El campo nombre de ítem y porcentaje no pueden estar vacíos');
                        }
                        else {
                            this.products[this.addProductIndex].items.push({
                                itemName: this.itemName,
                                itemPurchasePrice: this.itemPurchasePrice,
                                itemSalePrice: this.itemSalePrice,
                                itemPercent: this.itemPercent
                            })
                            this.resetItem();
                            this.addProduct = false;
                            this.addProductIndex = null;
                            this.showNotificationSuccess('Ítem agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.expenseName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            var index = this.actualExpenses.indexOf(this.currentRow);
                            this.actualExpenses[index].name = this.expenseName;
                            this.actualExpenses[index].value = this.expenseValue;
                            this.resetExpense();
                            this.currentRow = null;
                            this.$refs.expensesTable.setCurrentRow();
                            this.editExpense = false;
                            this.showNotificationSuccess('Gasto editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editTaxToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.taxName == '') {
                            this.showNotificationError('El campo nombre de impuesto no puede estar vacío');
                        }
                        else {
                            var index = this.actualTaxes.indexOf(this.currentTaxRow);
                            this.actualTaxes[index].name = this.taxName;
                            this.actualTaxes[index].value = this.taxValue;
                            this.actualTaxes[index].periodicity = this.taxPeriodicity;
                            this.resetTax();
                            this.currentTaxRow = null;
                            this.$refs.taxesTable.setCurrentRow();
                            this.editTax = false;
                            this.showNotificationSuccess('Impuesto editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseMethod (row) {
                // this.addProductIndex = row;
                this.resetExpense();
                this.addExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addTaxMethod (row) {
                // this.addProductIndex = row;
                this.resetTax();
                this.addTax = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName = '';
                this.itemPurchasePrice = '';
                this.itemSalePrice = '';
                this.itemPercent = '';
                this.productName= '';
                this.productQuantity= '';
                this.productCostUnity= '';
                this.productCostTotal= '';
                this.productMonthlyCost= '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.expenseName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            var id = this.actualExpenses.length + 1;
                            this.actualExpenses.push({
                                id: id,
                                name: this.expenseName,
                                value: this.expenseValue,
                                locked: false
                            })
                            this.resetExpense();
                            this.addExpense = false;
                            this.showNotificationSuccess('Gasto agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addTaxToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.taxName == '') {
                            this.showNotificationError('El campo nombre de impuesto no puede estar vacío');
                        }
                        else {
                            var id = this.actualTaxes.length + 1;
                            this.actualTaxes.push({
                                id: id,
                                name: this.taxName,
                                periodicity: this.taxPeriodicity,
                                value: this.taxValue,
                                locked: false
                            })
                            this.resetTax();
                            this.addTax = false;
                            this.showNotificationSuccess('Impuesto agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetExpense () {
                this.expenseName = '';
                this.expenseValue = '';   
                this.expenseLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetTax () {
                this.taxName = '';
                this.taxValue = '';   
                this.taxPeriodicity = 'Anual';   
                this.taxLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod () {
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseMethod () {
                this.expenseName= this.currentRow.name;
                this.expenseValue= this.currentRow.value;
                this.expenseLocked = this.currentRow.locked;
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editTaxMethod () {
                this.taxName= this.currentTaxRow.name;
                this.taxPeriodicity= this.currentTaxRow.periodicity;
                this.taxValue= this.currentTaxRow.value;
                this.taxLocked = this.currentTaxRow.locked;
                this.editTax = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeExpenseMethod () {
                this.actualExpenses.splice(this.actualExpenses.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeTaxMethod () {
                this.actualTaxes.splice(this.actualTaxes.indexOf(this.currentTaxRow),1);
                this.currentTaxRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddExpense () {
                this.addExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditExpense () {
                this.editExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddTax () {
                this.addTax = false;
                this.resetTax();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditTax () {
                this.editTax = false;
                this.resetTax();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveCosts () {
                if (this.allCostsComputed != 0) {
                    var periodicityArray = [];
                    periodicityArray.push({
                        periodicity: this.periodicity,
                        days: this.periodicity_days
                    })
                    this.costs.push({
                        expenses: this.actualExpenses,
                        taxes: this.actualTaxes,
                        totalExpenses: this.allExpensesMonthlyCostComputed,
                        totalTaxes: this.allTaxesMonthlyCostComputed
                    })
                    this.$store.dispatch('setTransportCosts', this.costs).then(()=>{
                        // this.$store.dispatch('setTotalCostsComputed', this.allCostsComputed).then(()=>{
                        this.$store.dispatch('setTotalCostsComputed', 0).then(()=>{
                            this.$store.dispatch('setPeriodicityArray', periodicityArray).then(()=>{
                                this.$store.dispatch('setCostsDataPopulate', true).then(()=>{
                                    // if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].salesPopulate == false) {
                                    //     this.$router.push('/asessments/new_asessment/customer/sales');
                                    // }
                                    // else {
                                    //     this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
                                    // }
                                    this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
                                }); 
                            });                            
                        });
                    });
                    
                }
                else {
                    this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                }
                
            }
        },
        mounted () {
            if (this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].transportCosts.length != 0) {
                    this.actualExpenses = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].transportCosts[0].expenses;
                    this.actualTaxes = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].transportCosts[0].taxes;
                    this.monthlyNumber = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].monthlyNumber;
                    this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].periodicityOperatingExpenses;
                    this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].daysOperatingExpenses;
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].daysOperatingExpenses != 0) {
                        this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].periodicityOperatingExpenses;
                        this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].daysOperatingExpenses;
                    }
                    this.expenses = Expenses;
                    this.taxes = Taxes;
                    for (let i=0; i<this.expenses.length;i++) {
                        this.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                    for (let i=0; i<this.taxes.length;i++) {
                        this.actualTaxes.push({
                            id: this.taxes[i].id,
                            name: this.taxes[i].name,
                            value: 0,
                            periodicity: 'Anual',
                            locked: true
                        })
                    }
                    this.taxes = Taxes;
                }
            }
            else if(this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].transportCosts.length != 0) {
                    this.actualExpenses = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].transportCosts[0].expenses;
                    this.actualTaxes = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].transportCosts[0].taxes;
                    this.monthlyNumber = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].monthlyNumber;
                    this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].periodicityOperatingExpenses;
                    this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].daysOperatingExpenses;
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].daysOperatingExpenses != 0) {
                        this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].periodicityOperatingExpenses;
                        this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].daysOperatingExpenses;
                    }
                    this.expenses = Expenses;
                    this.taxes = Taxes;
                    for (let i=0; i<this.expenses.length;i++) {
                        this.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                    for (let i=0; i<this.taxes.length;i++) {
                        this.actualTaxes.push({
                            id: this.taxes[i].id,
                            name: this.taxes[i].name,
                            value: 0,
                            periodicity: 'Anual',
                            locked: true
                        })
                    }
                    this.taxes = Taxes;
                }
            }
            else if(this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].transportCosts.length != 0) {
                    this.actualExpenses = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].transportCosts[0].expenses;
                    this.actualTaxes = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].transportCosts[0].taxes;
                    this.monthlyNumber = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].monthlyNumber;
                    this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].periodicityOperatingExpenses;
                    this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].daysOperatingExpenses;
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].daysOperatingExpenses != 0) {
                        this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].periodicityOperatingExpenses;
                        this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].daysOperatingExpenses;
                    }
                    this.expenses = Expenses;
                    this.taxes = Taxes;
                    for (let i=0; i<this.expenses.length;i++) {
                        this.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                    for (let i=0; i<this.taxes.length;i++) {
                        this.actualTaxes.push({
                            id: this.taxes[i].id,
                            name: this.taxes[i].name,
                            value: 0,
                            periodicity: 'Anual',
                            locked: true
                        })
                    }
                    this.taxes = Taxes;
                }
            }
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
